import { render } from "./AdminCompliance.vue?vue&type=template&id=0e6ed188"
import script from "./AdminCompliance.vue?vue&type=script&lang=js"
export * from "./AdminCompliance.vue?vue&type=script&lang=js"

import "./AdminCompliance.vue?vue&type=style&index=0&id=0e6ed188&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__